export const ASSISTANT_EVENTS = {
  EMBED_READY: "EMBED_READY",
  EMBED_ERROR: "EMBED_ERROR",
  NAVIGATE_REQUEST: "NAVIGATE_REQUEST",
  OPEN_URL: "OPEN_URL",
  OPEN_BLOB: "OPEN_BLOB",
  OPEN_ARTIFACT: "OPEN_ARTIFACT",
  OMNICASA_CONTEXT: "OMNICASA_CONTEXT",
};
